var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _mask, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g3, _path45, _g4, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _g5, _path106, _g6, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _g7, _g8, _path129, _path130;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyCategoryDetails = function SvgEmptyCategoryDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 325,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.996%",
    x2: "100%",
    y2: "49.996%",
    id: "EmptyCategoryDetails_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "24.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5FD2",
    offset: "29.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141AA",
    offset: "40.3%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.078%",
    y1: "88.278%",
    x2: "33.554%",
    y2: "-3.487%",
    id: "EmptyCategoryDetails_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.678%",
    y1: "26.037%",
    x2: "64.11%",
    y2: "78.685%",
    id: "EmptyCategoryDetails_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2EA",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "35.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "61.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "80.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.531%",
    y1: "77.526%",
    x2: "55.542%",
    y2: "15.866%",
    id: "EmptyCategoryDetails_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EB",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7F4",
    offset: "64.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "38.1%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED995A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7C45",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EA",
    offset: "24.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE1F1",
    offset: "57.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFE",
    offset: "96.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.99%",
    y1: "49.991%",
    x2: "-3.45%",
    y2: "49.137%",
    id: "EmptyCategoryDetails_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "64.429%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "71.506%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.127%",
    y1: "85.467%",
    x2: "92.697%",
    y2: "19.847%",
    id: "EmptyCategoryDetails_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141AA",
    offset: "16.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4343AC",
    offset: "23.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4848B4",
    offset: "27.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5252C2",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6060D5",
    offset: "32.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "33.7%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C6E6",
    offset: "23.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D5ED",
    offset: "54.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEDF8",
    offset: "88.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.797%",
    y1: "59.961%",
    x2: "94.438%",
    y2: "59.961%",
    id: "EmptyCategoryDetails_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.044%",
    y1: "50%",
    x2: "30.548%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6675",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7E76",
    offset: "21.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19B77",
    offset: "52.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AD78",
    offset: "80.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B378",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.989%",
    x2: "100%",
    y2: "49.989%",
    id: "EmptyCategoryDetails_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2EA",
    offset: "7.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "39.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2EA",
    offset: "7.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "39.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.002%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5857C7",
    offset: "28.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3C9E",
    offset: "75.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5857C7",
    offset: "28.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3C9E",
    offset: "75.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".002%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353C3",
    offset: "2.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373594",
    offset: "46.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252376",
    offset: "80.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.72%",
    y1: "1.062%",
    x2: "55.944%",
    y2: "100.481%",
    id: "EmptyCategoryDetails_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAEC",
    offset: "43.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E8FA",
    offset: "37.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D9F7",
    offset: "72.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "98.993%",
    y1: "79.572%",
    x2: "-17.022%",
    y2: "18.95%",
    id: "EmptyCategoryDetails_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E5FA",
    offset: "17.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4FD",
    offset: "40.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFE",
    offset: "65.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "69.6%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DBEE",
    offset: "16.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "50.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.123%",
    y1: "81.806%",
    x2: "84.489%",
    y2: "1.982%",
    id: "EmptyCategoryDetails_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDEF8",
    offset: "21.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0FB",
    offset: "68.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.839%",
    y1: "89.895%",
    x2: "39.724%",
    y2: "12.811%",
    id: "EmptyCategoryDetails_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "5.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F9",
    offset: "24.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D6EC",
    offset: "72.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "53.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F8",
    offset: "83.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.585%",
    x2: "50%",
    y2: "125.022%",
    id: "EmptyCategoryDetails_svg__O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.585%",
    x2: "50%",
    y2: "125.022%",
    id: "EmptyCategoryDetails_svg__R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.999%",
    x2: "99.999%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__S"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6FB",
    offset: "83.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "101.794%",
    y1: "50.001%",
    x2: ".27%",
    y2: "50.001%",
    id: "EmptyCategoryDetails_svg__T"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FB",
    offset: "27.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DCEF",
    offset: "74.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.677%",
    y1: "5.735%",
    x2: "21.773%",
    y2: "81.49%",
    id: "EmptyCategoryDetails_svg__U"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6867DE",
    offset: "23.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6060D3",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5453C0",
    offset: "65.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4341A6",
    offset: "85.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.176%",
    y1: "83.159%",
    x2: "71.907%",
    y2: "24.833%",
    id: "EmptyCategoryDetails_svg__V"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2EC",
    offset: "25.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEDF8",
    offset: "72.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.139%",
    y1: "73.857%",
    x2: "71.041%",
    y2: "40.578%",
    id: "EmptyCategoryDetails_svg__W"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6AE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.4%",
    y1: "74.292%",
    x2: "67.259%",
    y2: "14.737%",
    id: "EmptyCategoryDetails_svg__X"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E4",
    offset: "7.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "13.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FC",
    offset: "69%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__Y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE1F1",
    offset: "17.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F9",
    offset: "36.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "56.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "79.2%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.044%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyCategoryDetails_svg__ab"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-12.68%",
    y1: "47.541%",
    x2: "158.958%",
    y2: "52.286%",
    id: "EmptyCategoryDetails_svg__ae"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.319%",
    y1: "12.919%",
    x2: "35.168%",
    y2: "104.724%",
    id: "EmptyCategoryDetails_svg__af"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D33",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.999%",
    y2: "49.999%",
    id: "EmptyCategoryDetails_svg__ag"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF9",
    offset: "32.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E4F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.81%",
    y1: "80.478%",
    x2: "42.505%",
    y2: "18.82%",
    id: "EmptyCategoryDetails_svg__ah"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2116",
    offset: "9.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614830",
    offset: "22.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6946",
    offset: "35.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28358",
    offset: "48.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9866",
    offset: "61.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3A770",
    offset: "74.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB076",
    offset: "87.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B378",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m155.387 173.432-54.61 31.46c-2.666 1.535-7.029 1.535-9.694 0L62.9 188.656c-1.28-.737-1.94-1.7-1.99-2.672-.007 0-.007 4.284-.007 4.284-.003 1.014.66 2.028 1.997 2.798l28.183 16.236c2.665 1.536 7.028 1.536 9.693 0l54.61-31.46c1.386-.797 2.045-1.859 1.99-2.91v-4.172c-.05.972-.708 1.935-1.99 2.672Z",
    id: "EmptyCategoryDetails_svg__j"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EmptyCategoryDetails_svg__n",
    d: "M130.613 110.6 0 185.844v-110.6L130.614 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EmptyCategoryDetails_svg__q",
    d: "M151.834 114.358V31.774L108.112 6.588v82.584z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.27 31.775c-3.158 1.818-8.278 1.82-11.435 0l-.001 82.583c3.16 1.82 8.28 1.82 11.436 0 1.579-.908 2.368-2.1 2.368-3.293V28.481c0 1.192-.79 2.384-2.368 3.294Z",
    id: "EmptyCategoryDetails_svg__t"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EmptyCategoryDetails_svg__N",
    d: "m42.912 257.993 65.656 37.823-40.048 23.07-65.656-37.822z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.213 285.407c.232.538.345 1.12.33 1.705a9.431 9.431 0 0 1-4.27 7.382l2.294 1.322a9.43 9.43 0 0 0 4.272-7.382c0-2.041-1.085-3.171-2.626-3.027Z",
    id: "EmptyCategoryDetails_svg__Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.242 195.43v12.174c0 2.461 1.63 4.922 4.889 6.8 6.52 3.755 17.088 3.754 23.607 0 3.26-1.878 4.89-4.34 4.889-6.8V195.43h-33.385Z",
    id: "EmptyCategoryDetails_svg__aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.627 201.627a1.039 1.039 0 0 0-.527-.834c.361-.827.55-1.72.552-2.622a1.088 1.088 0 0 0-.996-.967c-.5 0-.003.967-.003.967h-.231c0 2.402-1.668 4.686-4.698 6.431-6.494 3.74-17.06 3.74-23.555 0-3.029-1.745-4.697-4.029-4.697-6.43h-.256s.496-.968-.003-.968c-.52.035-.935.448-.972.967.003.898.19 1.787.549 2.61-.317.17-.524.49-.549.846a6.59 6.59 0 0 0 .548 2.61c-.316.17-.523.489-.548.846 0 2.859 1.887 5.52 5.313 7.494 6.834 3.935 17.952 3.935 24.785 0 3.427-1.974 5.314-4.636 5.313-7.494a1.13 1.13 0 0 0-.552-.834c.365-.825.545-1.72.527-2.622Zm-5.903 9.887c-6.494 3.74-17.06 3.74-23.555 0-2.844-1.639-4.488-3.753-4.678-5.993a12.024 12.024 0 0 0 4.063 3.6c6.834 3.936 17.952 3.936 24.785 0a12.038 12.038 0 0 0 4.064-3.6c-.19 2.24-1.834 4.354-4.679 5.993Zm0-3.456c-6.494 3.74-17.06 3.74-23.555 0-2.844-1.64-4.489-3.753-4.678-5.994a12.025 12.025 0 0 0 4.063 3.602c6.834 3.935 17.952 3.935 24.785 0a12.04 12.04 0 0 0 4.064-3.602c-.189 2.241-1.834 4.355-4.679 5.994Z",
    id: "EmptyCategoryDetails_svg__ad"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.3%",
    y: "-12.6%",
    width: "114.5%",
    height: "135.3%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__i"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-16%",
    y: "-4.6%",
    width: "132%",
    height: "113%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__p"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50.7%",
    y: "-5.7%",
    width: "201.4%",
    height: "116%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__s"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-6.6%",
    y: "-8.2%",
    width: "113.2%",
    height: "123%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__M"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-106.6%",
    y: "-48%",
    width: "313.2%",
    height: "234.3%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__P"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21%",
    y: "-22.9%",
    width: "141.9%",
    height: "164.3%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__Z"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-19.8%",
    y: "-27.3%",
    width: "139.5%",
    height: "176.4%",
    filterUnits: "objectBoundingBox",
    id: "EmptyCategoryDetails_svg__ac"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m53.955 163.373-20.993 12.094a7.942 7.942 0 0 0-3.98 7.016 7.943 7.943 0 0 0 4.216 6.877l107.498 62.152",
    stroke: "#4141AA",
    strokeWidth: 1.229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m209.572 246.339-3.635-2.094c1.407.81 1.407 2.137 0 2.948L142.218 283.9a5.687 5.687 0 0 1-5.117 0l3.561 2.051-1.13.65h3.635a5.385 5.385 0 0 0 2.686-.607l63.719-36.707c1.407-.811 1.407-2.137 0-2.948Z",
    fill: "url(#EmptyCategoryDetails_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.937 247.193 142.218 283.9a5.687 5.687 0 0 1-5.117 0l-25.89-14.915a1.836 1.836 0 0 1-1.048-1.386c-.007 0-.007 2.006-.007 2.006.058.646.462 1.21 1.055 1.474l25.89 14.915a5.69 5.69 0 0 0 5.117 0l63.72-36.707a1.717 1.717 0 0 0 1.044-1.61c.01 0 .01-1.958.01-1.958a1.79 1.79 0 0 1-1.055 1.474Z",
    fill: "url(#EmptyCategoryDetails_svg__b)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.989 245.67c0 .017.004.033.004.049 0-.016-.001-.033-.004-.049Z",
    fill: "#3366A3",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.1 283.9c1.61.81 3.51.81 5.118 0l63.72-36.707c1.406-.81 1.406-2.137 0-2.948l-25.89-14.915a5.69 5.69 0 0 0-5.118 0l-63.719 36.707c-1.407.811-1.407 2.137 0 2.948l25.89 14.915Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "m178.98 234.757 3.244-1.87-3.245-1.869-3.245 1.87zM173.514 237.906l3.246-1.87-3.246-1.87-3.245 1.87zM168.049 241.054l3.245-1.87-3.245-1.868-3.246 1.869zM162.583 244.202l3.245-1.868-3.245-1.87-3.245 1.87zM157.117 247.35l3.246-1.869-3.246-1.868-3.244 1.868zM151.652 250.5l3.246-1.87-3.246-1.87-3.245 1.87zM146.187 253.648l3.245-1.87-3.245-1.869-3.245 1.87zM140.721 256.797l3.245-1.87-3.245-1.869-3.245 1.87zM135.255 259.945l3.246-1.87-3.246-1.869-3.244 1.87zM129.79 263.094l3.246-1.87-3.245-1.869-3.246 1.87zM124.325 266.243l3.245-1.87-3.245-1.87-3.245 1.87zM118.86 269.39l3.244-1.869-3.245-1.869-3.245 1.87zM181.856 239.397l5.834-3.36-3.245-1.87-5.834 3.361zM184.874 243.694l8.055-4.64-3.246-1.87-8.054 4.64zM188.118 248.121l10.276-5.919-3.246-1.869-10.274 5.92zM199.173 249.373l5.834-3.36-4.393-2.532-5.834 3.362zM191.119 254.014l5.834-3.362-4.393-2.53-5.835 3.36zM183.065 258.653l5.833-3.36-4.393-2.531-5.834 3.36zM155.293 274.652l5.834-3.361-4.394-2.531-5.834 3.361zM141.643 282.515l11.443-6.592-4.394-2.531-11.443 6.592zM163.334 270.02l17.51-10.087-4.394-2.532-17.51 10.088zM174.861 243.427l4.775-2.75-3.245-1.87-4.776 2.75zM177.879 247.724l4.775-2.751-3.246-1.87-4.774 2.75zM180.975 252.065l4.774-2.75-3.245-1.87-4.774 2.75zM173.98 256.094l4.774-2.75-3.245-1.87-4.774 2.751zM166.985 260.124l4.774-2.75-3.245-1.87-4.774 2.75zM159.99 264.154l4.775-2.751-3.246-1.87-4.774 2.751zM152.995 268.183l4.775-2.75-3.246-1.87-4.774 2.75zM146 272.212l4.775-2.75-3.246-1.869-4.774 2.75zM134.879 278.62l8.901-5.129-3.245-1.869-8.9 5.128zM170.884 251.753l4.775-2.75-3.246-1.87-4.774 2.75zM163.89 255.783l4.774-2.75-3.245-1.87-4.774 2.75zM156.895 259.812l4.774-2.75-3.245-1.87-4.774 2.75zM149.9 263.841l4.774-2.75-3.245-1.87-4.775 2.751zM142.905 267.871l4.774-2.75-3.245-1.87-4.775 2.75zM129.563 275.556l11.12-6.406-3.244-1.87-11.12 6.407zM167.866 247.456l4.774-2.75-3.244-1.87-4.775 2.75zM160.872 251.486l4.774-2.75-3.245-1.87-4.775 2.75zM153.877 255.515l4.774-2.75-3.245-1.87-4.775 2.75zM146.882 259.545l4.774-2.75-3.245-1.87-4.775 2.751zM139.887 263.574l4.774-2.75-3.245-1.87-4.774 2.75zM132.892 267.604l4.774-2.75-3.245-1.87-4.774 2.75zM124.325 272.539l6.346-3.656-3.245-1.87-6.346 3.657z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.049 1.822C14.348-.31 10.994-.508 8.572.897L3.885 3.615c2.422-1.404 5.776-1.207 9.477.925 7.356 4.238 13.3 14.509 13.275 22.94-.011 4.19-1.494 7.137-3.885 8.524l4.687-2.718c2.39-1.386 3.873-4.334 3.885-8.524.024-8.43-5.919-18.702-13.275-22.94Z",
    fill: "url(#EmptyCategoryDetails_svg__c)",
    transform: "translate(76.059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42 4.54C82.068.304 76.084 3.704 76.06 12.135c-.024 8.433 5.922 18.706 13.275 22.942 7.356 4.238 13.338.836 13.362-7.597.024-8.431-5.92-18.702-13.275-22.94Z",
    fill: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.385 8.36c-1.32-.76-2.394-.15-2.399 1.363a5.238 5.238 0 0 0 2.384 4.119c1.32.76 2.394.15 2.398-1.364a5.239 5.239 0 0 0-2.383-4.118Z",
    fill: "#34318F"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#34318F",
    fillRule: "nonzero",
    d: "M92.539 20.73v-2.253l-6.324-3.643v2.252l1.353.78v8.603l-1.353-.78v2.253l6.324 3.643v-2.252l-1.352-.78V19.95z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256.865 71.891c-1.036.6-1.287 3.177-1.29 4.395l7.78-4.51c.003-1.22.254-3.796 1.29-4.396l-7.78 4.511Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m244.876 39.838-7.78 4.511c1.068.615 3.454 1.71 4.492 1.107l7.781-4.51c-1.039.601-3.426-.493-4.493-1.108ZM261.5 59.272c-3.7-2.132-6.687-7.292-6.675-11.534.006-2.106.752-3.589 1.954-4.286L249 47.964c-1.202.697-1.948 2.18-1.954 4.285-.012 4.242 2.974 9.402 6.674 11.534 1.86 1.071 3.544 1.17 4.76.466l7.781-4.512c-1.217.706-2.901.606-4.76-.465Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "m270.397 63.534-.013 4.332 7.78-4.512.013-4.332z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m259.685 31.417-7.78 4.512 3.778 2.176 7.78-4.511zM273.25 53.837a25.258 25.258 0 0 0-.645-2.175c-.868-2.205 1.094-3.919 2.025-4.459l-7.78 4.511c-.931.54-2.893 2.254-2.025 4.46.25.723.467 1.45.645 2.174.433 2.187 3.639 4.443 4.927 5.185l7.78-4.511c-1.288-.742-4.494-2.998-4.927-5.185Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.911 42.82a3.02 3.02 0 0 1-.852-.743 26.86 26.86 0 0 0-1.564-1.647c-1.69-1.477-2.036-5.36-2.032-6.836l-7.78 4.511c-.004 1.477.342 5.359 2.032 6.836.54.522 1.06 1.07 1.564 1.648.235.299.524.55.852.743 1.45.835 3.262.146 4.092-.238l7.78-4.511c-.83.384-2.641 1.073-4.092.237Z",
    fill: "url(#EmptyCategoryDetails_svg__d)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.444 67.367c.444-1.682 3.652-.244 4.94.498l.013-4.332c-1.288-.742-4.494-2.998-4.927-5.185a25.328 25.328 0 0 0-.645-2.175c-.88-2.233 1.145-3.963 2.06-4.479l-2.662-4.6c-.83.384-2.641 1.073-4.092.238a3.015 3.015 0 0 1-.852-.743 26.89 26.89 0 0 0-1.564-1.648c-1.69-1.477-2.036-5.359-2.032-6.836l-3.778-2.177c-.004 1.477-.37 4.949-2.06 4.48a9.025 9.025 0 0 0-1.572-.16 1.483 1.483 0 0 1-.86-.243c-1.47-.847-3.319-3.644-4.067-4.938l-2.68 1.524c1.04 1.641 2.915 5.617 2.025 6.831-.26.455-.48.932-.655 1.426-.445 1.682-3.653.243-4.94-.499l-.013 4.332c1.288.743 4.494 2.998 4.927 5.186.182.726.397 1.45.645 2.174.88 2.234-1.145 3.964-2.056 4.482l2.661 4.604c.754-.432 2.613-1.094 4.082-.248.331.193.622.446.859.747a25.632 25.632 0 0 0 1.568 1.65c1.685 1.856 2.032 5.357 2.028 6.834l3.778 2.176c.004-1.476.37-4.948 2.06-4.479a8.609 8.609 0 0 0 1.572.16c.305-.01.605.075.86.243 1.47.847 3.319 3.645 4.071 4.944l2.675-1.53c-.905-1.565-2.913-5.617-2.023-6.832.262-.453.482-.93.654-1.425Zm-11.724-3.584c-3.7-2.132-6.686-7.292-6.674-11.534.012-4.238 3.017-5.95 6.718-3.82 3.696 2.13 6.682 7.294 6.67 11.532-.012 4.243-3.018 5.951-6.714 3.822Z",
    fill: "#F7F7FC",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.385 67.865c-1.289-.742-4.497-2.18-4.94-.498a8.306 8.306 0 0 1-.655 1.425c-.89 1.215 1.118 5.267 2.023 6.832l7.78-4.511a22.566 22.566 0 0 1-2.005-4.525l-2.203 1.277Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "m272.003 42.583-7.78 4.511 2.662 4.6 7.78-4.512zM251.126 30.556l-7.78 4.511c.748 1.294 2.598 4.091 4.067 4.938.254.167.555.252.86.243.528.007 1.054.06 1.572.16 1.69.469 2.056-3.003 2.06-4.48l2.235-1.295a22.197 22.197 0 0 1-3.014-4.077Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__e)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M305.966 104.97h-18.979l-3.46-2.211H157.883L147.5 108.74l47.104 27.134h18.6l3.839 2.211 140.76.001z",
    transform: "translate(2)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#4141AA",
    fillRule: "nonzero",
    d: "M227.689 133.105V57.621L183.84 32.36v75.484z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m178.89 41.09 7.627-4.394 40.15 23.129-7.626 4.393z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6AE2",
    fillRule: "nonzero",
    d: "M219.042 138.086V62.601l-43.849-25.26v75.485z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__f)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m213.204 60.39-40.01-23.049v75.485l40.01 23.05z",
    transform: "translate(2)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#5555C6",
    fillRule: "nonzero",
    d: "M228.71 57.03 184.86 31.772l-1.02.588 42.826 24.672-7.626 4.393-42.827-24.672-1.02.588 43.848 25.26z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M204.24 98.004v-7.933l-15.267-8.796v7.934z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4141AA",
    fillRule: "nonzero",
    d: "m228.71 57.03-9.668 5.57v75.486l9.667-5.569z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.567 99.465a7.293 7.293 0 0 1 3.309-5.718c1.827-1.052 3.308-.199 3.308 1.906a7.292 7.292 0 0 1-3.308 5.717c-1.827 1.053-3.309.2-3.309-1.905Zm0-20.546a7.292 7.292 0 0 1 3.309-5.717c1.827-1.053 3.308-.2 3.308 1.905a7.293 7.293 0 0 1-3.308 5.717c-1.827 1.053-3.309.2-3.309-1.905Zm0 41.091a7.292 7.292 0 0 1 3.309-5.717c1.827-1.052 3.308-.2 3.308 1.906a7.293 7.293 0 0 1-3.308 5.717c-1.827 1.053-3.309.2-3.309-1.906Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m201.155 42.258 2.76 1.603v3.62a6.259 6.259 0 0 1-1.445 1.119c-3.283 1.89-8.606 1.891-11.889 0v73.424l-34.664-19.97V16.198l45.238 26.06Z",
    fill: "#D67747",
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m201.373 45.384-42.76-24.633-9.695 5.585 42.76 24.633a10.753 10.753 0 0 0 9.695 0c2.671-1.54 2.672-4.046 0-5.585Z",
    fill: "#EAE5E4",
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "m190.58 48.6-45.454-26.185v85.857l45.454 26.185zM202.47 48.6c3.281-1.891 3.283-4.957 0-6.849l-45.456-26.185-1.097.631 45.456 26.186c2.672 1.54 2.671 4.045 0 5.585a10.751 10.751 0 0 1-9.696 0l-45.455-26.185-1.096.631L190.58 48.6c3.283 1.891 8.606 1.89 11.889 0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M200.47 48.6c-3.283 1.89-8.606 1.891-11.889 0v85.856c3.284 1.892 8.607 1.892 11.89 0 1.64-.944 2.46-2.183 2.46-3.423V45.176c0 1.239-.82 2.478-2.461 3.424Z",
    fill: "url(#EmptyCategoryDetails_svg__g)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M178.34 91.073V77.88l-20.974-12.083v13.195z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.638 95.593v-4.841c3.17.952 7.17.663 9.832-.87a4.894 4.894 0 0 0 2.265-2.399c.126-.327.193-.675.197-1.026.018 0 0 4.84 0 4.84.003 1.24-.821 2.48-2.462 3.425-2.662 1.533-6.663 1.823-9.832.87Zm9.832-37.514a4.89 4.89 0 0 0 2.265-2.399c.126-.327.193-.675.197-1.025v2.052c.003 1.24-.821 2.478-2.462 3.424-3.283 1.89-8.605 1.891-11.888 0V58.08c3.282 1.891 8.605 1.89 11.888 0Zm-.001 5.684a4.894 4.894 0 0 0 2.265-2.399c.127-.327.194-.675.197-1.026v2.053c.003 1.24-.821 2.478-2.462 3.424-3.282 1.89-8.605 1.891-11.888 0v-2.052c3.283 1.891 8.605 1.89 11.888 0Zm0 53.477a4.89 4.89 0 0 0 2.264-2.398c.127-.327.194-.675.197-1.026v2.053c.003 1.24-.82 2.478-2.462 3.424-3.283 1.89-8.604 1.891-11.887 0v-2.052c3.282 1.891 8.604 1.89 11.887 0Zm-.001 5.684a4.891 4.891 0 0 0 2.265-2.398c.127-.327.193-.675.197-1.026v2.053c.003 1.239-.821 2.478-2.462 3.424-3.283 1.89-8.605 1.89-11.888 0v-2.052c3.283 1.89 8.605 1.89 11.888 0Z",
    fill: "#F0CEC3",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.008 175.346c.518-1.287-.082-2.696-1.814-3.693l-28.183-16.236c-2.667-1.536-7.028-1.536-9.694 0l-54.61 31.46c-2.666 1.535-2.666 4.048 0 5.584 0 0 28.434 16.37 28.564 16.434l-4.341 1.559h6.971a13.28 13.28 0 0 0 6.684-1.757l22.663-13.056h46.816v-20.295h-13.056Z",
    fill: "url(#EmptyCategoryDetails_svg__h)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.203 151.612c-2.666-1.535-7.027-1.535-9.694 0l-54.61 31.46c-2.665 1.536-2.665 4.048 0 5.584l28.184 16.236c2.665 1.535 7.028 1.535 9.693 0l54.61-31.46c2.667-1.535 2.667-4.048 0-5.584l-28.183-16.236Z",
    fill: "#F7F7FC",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m132.147 170.928-.474.007-35.232 20.295h28.049l30.897-17.798c1.206-.695 1.86-1.59 1.974-2.504h-25.214Z",
    fill: "#D3D8F2",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__i)",
    xlinkHref: "#EmptyCategoryDetails_svg__j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__k)",
    xlinkHref: "#EmptyCategoryDetails_svg__j"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.774 162.414a46.383 46.383 0 0 1-2.197-14.783l-3.878-2.234c0 .989.002 2.495.13 4.392l-31.483 18.137c0 3.315.004 13.26 6.095 23.304l35.232-20.295-3.899-8.52Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6B9BE",
    fillRule: "nonzero",
    d: "m127.577 147.63-35.231 20.296-3.877-2.233 35.23-20.296z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.44 191.23c-6.09-10.043-6.094-19.99-6.094-23.304l-3.877-2.234a51.799 51.799 0 0 0 4.791 22.555l5.18 2.983Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.691 174.287a44.5 44.5 0 0 0 1.148 6.04l35.233-20.297a44.958 44.958 0 0 1-1.148-6.04l-35.233 20.297Z",
    fill: "#C6CBE7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.91 9.986c-.001-3.072-2.18-4.328-4.846-2.793L50.451 82.436c-2.666 1.535-4.847 5.304-4.847 8.376v87.355l140.305-80.825.002-87.356Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.808 4.167 43.195 79.409c-2.665 1.536-4.847 5.305-4.847 8.377v87.355l5.256 3.026V90.812c0-3.072 2.181-6.84 4.847-8.376L179.064 7.193c.852-.57 1.9-.766 2.902-.544l-4.203-2.387c-.88-.925-2.327-1.034-3.955-.095Z",
    fill: "url(#EmptyCategoryDetails_svg__l)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.604 178.167v17.661c0 3.071 2.181 4.328 4.847 2.792l130.613-75.243c2.665-1.535 4.847-5.304 4.847-8.375l-.002-17.66-140.305 80.825Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.604 195.828v-17.661l-5.256-3.026v17.66c0 1.545.553 2.63 1.44 3.131l5.04 2.882c-.758-.551-1.224-1.573-1.224-2.986Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__m)",
    fillRule: "nonzero",
    d: "M179.063 100.133 48.451 175.375V88.02l130.613-75.243z",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.45 12.777)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "EmptyCategoryDetails_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmptyCategoryDetails_svg__n"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EmptyCategoryDetails_svg__o)"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1C6B",
    fillRule: "nonzero",
    d: "M127.85 22.828v77.326L86.413 76.286V-1.042z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m81.626 7.404 7.378-4.25 38.845 22.377-7.379 4.25z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB42E",
    fillRule: "nonzero",
    d: "m120.47 28.216.002 77.328-42.423-24.44V3.779z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#4141AA",
    fillRule: "nonzero",
    d: "M129.825 22.828 87.403-1.61l-.99.568 41.436 23.87-7.379 4.25-41.434-23.87-.986.57 42.42 24.438z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M106.151 54.791v7.677L91.38 53.96v-7.677z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1C6B",
    fillRule: "nonzero",
    d: "M129.824 22.828v77.327l-9.352 5.389-.002-77.328z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "M127.713 58.478v13.54l-5.13 2.955v-13.54z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m119.092 23.933 2.655 1.542v3.481a6.018 6.018 0 0 1-1.39 1.077c-3.158 1.818-8.278 1.819-11.435 0v70.624L75.578 81.45V-1.134l43.513 25.067Z",
    fill: "#2D7271",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.302 26.94 78.172 3.244l-9.326 5.372 41.13 23.694a10.344 10.344 0 0 0 9.326 0c2.57-1.48 2.57-3.891 0-5.372Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.913 -1.742)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__p)",
    xlinkHref: "#EmptyCategoryDetails_svg__q"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__r)",
    xlinkHref: "#EmptyCategoryDetails_svg__q"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.357 30.033c3.157-1.82 3.158-4.769 0-6.588L76.634-1.742l-1.055.608 43.723 25.187c2.57 1.481 2.57 3.891 0 5.372a10.342 10.342 0 0 1-9.326 0L66.253 4.238l-1.054.607 43.723 25.188c3.157 1.819 8.277 1.818 11.435 0Z",
    fill: "#236570",
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.913 -1.742)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__s)",
    xlinkHref: "#EmptyCategoryDetails_svg__t"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__u)",
    xlinkHref: "#EmptyCategoryDetails_svg__t"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M97.147 70.887v-12.69L76.973 46.574v12.69z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.813 76.976V72.32c3.049.916 6.897.638 9.457-.837a4.705 4.705 0 0 0 2.178-2.307c.123-.315.187-.65.19-.987.018 0 0 4.656 0 4.656.004 1.192-.79 2.384-2.368 3.294-2.56 1.475-6.408 1.753-9.457.837Zm9.456-30.616a4.71 4.71 0 0 0 2.18-2.307c.121-.315.185-.65.189-.987v1.974c.003 1.192-.79 2.384-2.369 3.293-3.157 1.82-8.277 1.82-11.434 0V46.36c3.158 1.819 8.277 1.818 11.434 0Zm0 51.439a4.704 4.704 0 0 0 2.179-2.307 2.82 2.82 0 0 0 .189-.987v1.974c.003 1.193-.79 2.384-2.368 3.294-3.158 1.818-8.277 1.819-11.435 0v-1.974c3.158 1.82 8.277 1.819 11.435 0Z",
    fill: "#96D0CF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(-42.913 -1.742)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#D67747",
    fillRule: "nonzero",
    d: "M103.259 37.538v72.888l-39.057-22.5V15.038z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m59.689 22.999 6.955-4.007 36.615 21.093-6.955 4.007z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "m96.304 42.616.001 72.89L56.316 92.47l.002-72.889zM105.121 37.538 65.134 14.5l-.932.536 39.057 22.5-6.955 4.005-39.056-22.499-.93.537 39.986 23.036z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m82.807 67.667-.001 7.236-13.923-8.02v-7.237z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF7C45",
    fillRule: "nonzero",
    d: "M105.12 37.538v72.889l-8.815 5.08-.001-72.891z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "M105.12 97.68v5.93l-8.815 5.079v-5.93zM105.12 44.273v5.929l-8.815 5.08v-5.93z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "M94.675 101.82v5.93l1.63.939v-5.93zM94.675 48.413v5.93l1.63.938v-5.929z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__v)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M68.798 144.338h8.837l54.304-31.283-4.418-19.634z",
    transform: "translate(-42.913 -1.742)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "M84.216 90.115 17.636 51.76l-58.724 50.918 66.581 38.355z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "M22.896 130.684-40.885 93.94l2.217 8.84 63.782 36.743z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "m84.608 91.678-58.723 50.918-2.217-8.838L82.39 82.84z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#4141AA",
    fillRule: "nonzero",
    d: "M61.103 107.909 47.68 119.547l-.507-2.02 13.423-11.639z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "M82.39 82.84 15.81 44.484l-58.723 50.918 66.58 38.356z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8F2",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M87.288 88.394 61.108 73.31 38.016 93.333l26.181 15.082z",
    transform: "translate(-42.913 -1.742)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "m25.885 142.596-2.217-8.838-66.581-38.356.392 1.564 65.032 37.464 1.434 5.71-65.033-37.462.392 1.563z"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__w)",
    fillRule: "nonzero",
    opacity: 0.5,
    d: "M137.477 124.09V51.2l.93-.536 2.212 1.274 4.743-2.733v-2.547l.932-.537v-9.693l1.054-.608 2.506 1.443 6.82-3.93v-2.885l1.054-.608 3.79 2.183 2.346 1.351 1.936-1.115v-2.702l.988-.57 11.487 6.618v64.983l.788-.455.001-87.356L48.451 88.02v87.355z",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__x)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M262.201 241.427h-14.127l44.476 25.622-66.515 38.317h14.127l66.515-38.317z",
    transform: "translate(2)"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#478A89",
    fillRule: "nonzero",
    d: "m250.074 240.235-66.516 38.317 44.476 25.621 66.515-38.317z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "M186.274 278.9v-5.752L227 296.608v5.752z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#52A4A3",
    fillRule: "nonzero",
    d: "m250.074 233.29-66.516 38.317 44.477 25.621 66.514-38.317z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7271",
    fillRule: "nonzero",
    d: "m228.035 297.228-44.477-25.621v1.193l43.44 25.024v5.753l-43.44-25.025v1.193l44.477 25.621zM226.322 246.972l-19.012 10.953 44.476 25.621 19.012-10.952z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7271",
    fillRule: "nonzero",
    d: "m294.55 258.91-66.515 38.318v8.138l66.515-38.317z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#478A89",
    fillRule: "nonzero",
    d: "m280.983 266.727-5.868 3.38v8.138l5.868-3.38zM241.602 289.412l5.868-3.38v8.139l-5.868 3.38z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#71CDCC",
    fillRule: "nonzero",
    d: "m235.925 260.69-4.803 2.766 11.06 6.372 4.803-2.766z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#52A4A3",
    fillRule: "nonzero",
    d: "m270.798 272.594-19.012 10.952-.127 8.212 19.01-10.953z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__y)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M334.182 138.63h-14.127l44.476 25.621-74.748 43.06h14.127l74.748-43.06z",
    transform: "translate(2)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6AE2",
    fillRule: "nonzero",
    d: "m305.409 127.813-74.749 43.06 61.122 35.211 74.749-43.06z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "M291.904 198.868v5.919l-58.99-33.983v-5.919z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "M364.28 157.175v5.919l-72.376 41.693v-5.919z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6AE2",
    fillRule: "nonzero",
    d: "m305.409 120.667-74.749 43.06 61.122 35.212 74.749-43.061z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#5555C6",
    fillRule: "nonzero",
    d: "m230.66 172.1 61.123 35.212v-1.228l-60.057-34.596v-5.919l60.057 34.597v-1.227l-61.123-35.211z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#34318F",
    fillRule: "nonzero",
    d: "m291.783 198.939 74.748-43.061v1.227l-74.748 43.061zM291.783 206.084l74.748-43.06v1.227l-74.748 43.06z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1C2D",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    d: "m295.313 132.764-45.654 26.3 48.219 27.778 45.654-26.3z",
    transform: "translate(2)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#5555C6",
    fillRule: "nonzero",
    d: "m263.454 165.858.073-13.631-11.868 6.837z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m294.64 151.985-1.48.853 17.527 10.097 1.48-.853zM288.132 159.313l-1.48.853 11.312 6.518 1.48-.853z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#172E49",
    fillRule: "nonzero",
    d: "m231.726 171.488 1.187-.684v-4.552l-1.187-.683z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "m304.796 178.807 74.157 53.54 60.056-34.597-74.156-53.54z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__z)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M406.525 173.288h-14.128l44.477 25.621-60.057 34.597h14.128L451 198.91z",
    transform: "translate(2)"
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "m305.573 172.185 74.157 53.54-.913 7.781-74.157-53.539z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3B378",
    fillRule: "nonzero",
    d: "m305.573 172.185 74.157 53.54 60.056-34.597-74.156-53.54z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m353.27 206.621-21.237-15.333-.913 7.783 21.238 15.332z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "m413.327 172.025-21.238-15.333-60.056 34.596 21.237 15.333z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#4141AA",
    fillRule: "nonzero",
    d: "m378.555 180.264-3.07-2.215-8.68 5 3.07 2.215z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m437.8 192.306-.593 5.4-57.903 33.311.65-5.474c19.282-11.08 38.564-22.159 57.847-33.237Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m378.817 233.506 60.056-34.597.137-1.159-58.97 33.925c.272-2.297.396-3.344.65-5.474a1037262.5 1037262.5 0 0 1 58.956-33.875l.14-1.198-60.056 34.597-.913 7.78Z",
    fill: "#D67747",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.752 113.462a6.94 6.94 0 0 1 3.15-5.442c1.739-1.002 3.149-.19 3.149 1.814a6.942 6.942 0 0 1-3.15 5.442c-1.739 1.002-3.149.19-3.149-1.814Z",
    fill: "#FFB42E",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.233 114.913c0-3.606 2.537-7.991 5.668-9.794 3.13-1.804 5.668-.342 5.668 3.264s-2.537 7.991-5.668 9.795c-3.13 1.803-5.668.341-5.668-3.265Z",
    stroke: "#F77C21",
    strokeWidth: 1.229,
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.814 117.459c0-6.418 4.515-14.223 10.087-17.432 5.572-3.21 10.088-.608 10.088 5.81 0 6.418-4.516 14.223-10.088 17.433-5.572 3.21-10.087.608-10.087-5.811Z",
    stroke: "#DB6719",
    strokeWidth: 0.922,
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.136 122.457c0-11.939 8.4-26.457 18.764-32.427 10.366-5.97 18.767-1.131 18.767 10.809 0 11.939-8.401 26.457-18.767 32.427-10.364 5.971-18.764 1.131-18.764-10.809Z",
    stroke: "#7F3D11",
    strokeWidth: 0.615,
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__A)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M119.002 206.689h30.139v5.527h-30.139z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__B)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M132.592 198.708h30.139v5.527h-30.139z",
    transform: "translate(2)"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.927 202.534c0-4.342-2.759-4.468-2.759-4.468a11.411 11.411 0 0 1-3.919-1.004c-2.393-.993-5.767-.609-3.882 2.861.019.044.04.087.065.128.158.226.367.41.612.535l6.025 3.527c.919.524 3.836-.686 3.858-1.58Z",
    fill: "url(#EmptyCategoryDetails_svg__C)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M137.91 202.145c-.052.891-2.93 2.077-3.84 1.558l-6.026-3.526a5.565 5.565 0 0 1-.85-.618c.056.12.104.235.173.364.019.044.04.087.065.128.158.226.367.41.612.535l6.025 3.527c.86.49 3.474-.54 3.82-1.407a.948.948 0 0 0 .026-.176 2.826 2.826 0 0 0-.005-.385Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M136.805 197.495a25.32 25.32 0 0 0-3.21.634c-.02.23-.096.453-.222.646-.026.028-.047.056-.07.085-.494.342-.995.883.175 1.616a1.626 1.626 0 0 0 2.107-.149 1.92 1.92 0 0 1 .68-.77c.195-.135.417-.228.65-.275.001-.02.003-.04.007-.059 0 0 .181-1.728-.117-1.728Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 155.04c-2.725.049-9.535.17-12.258.22 1.014 8.171 3.054 15.594 4.417 23.508 1.462 7.691 3.11 13.096 4.55 19.497.525 1.192 2.935.741 3.424-.406.38-5.895.82-13.077-.932-19.878.293-7.332.97-15.539.799-22.94Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M122.19 210.512c0-4.342-2.757-4.468-2.757-4.468a11.415 11.415 0 0 1-3.92-1.004c-2.393-.993-5.767-.609-3.881 2.861.018.044.04.087.064.128.157.226.367.41.612.535l6.025 3.527c.918.524 3.836-.686 3.858-1.58Z",
    fill: "url(#EmptyCategoryDetails_svg__D)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M124.174 210.123c-.052.891-2.93 2.077-3.84 1.558l-6.026-3.526a5.595 5.595 0 0 1-.85-.618c.056.12.104.235.174.364.018.044.04.087.064.128.158.226.367.41.612.535l6.025 3.527c.86.49 3.474-.54 3.82-1.407a.899.899 0 0 0 .026-.176 2.74 2.74 0 0 0-.005-.385Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M123.069 205.473a25.344 25.344 0 0 0-3.21.634c-.02.23-.096.453-.222.646-.025.028-.047.056-.07.085-.494.342-.996.883.174 1.616a1.626 1.626 0 0 0 2.107-.15c.153-.312.388-.579.68-.77.196-.134.418-.227.651-.274 0-.02.003-.04.007-.059 0 0 .18-1.728-.117-1.728Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.204 174.472c.746-3.513 9.337-3.95 8.773-17.763-2.696-.395-16.295 5.968-18.99 5.573-.337 8.227.46 15.883.51 23.912.183 7.827.926 13.427 1.298 19.977.323 1.263 2.775 1.21 3.444.159 1.34-5.754 2.95-12.77 2.334-19.764.803-3.875 1.758-7.982 2.631-12.094Z",
    fill: "url(#EmptyCategoryDetails_svg__E)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M128.76 129.887c9.594 6.397 10.737 19.099 5.55 27.16 0 0 1.116-17.861-5.55-27.16Z",
    fill: "url(#EmptyCategoryDetails_svg__F)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M129.199 164.54c-5.84 3.27-11.95 3.277-14.032-.743.78-7.484 1.51-13.574.006-20.747.444-3.962 1.34-6.369.831-8.68 3.212-.439 5.979-5.36 7.843-5.74 7.985-1.627 11.864 12.57 11.197 27.706a11.024 11.024 0 0 1-5.845 8.204Z",
    fill: "url(#EmptyCategoryDetails_svg__G)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M130.275 129.533c-1.732-1.248-1.475-2.065-1.216-3.765.347-.94.524-1.933.522-2.934 0-3.785-2.415-7.056-5.377-6.853-5.967.409-4.905 3.542-4.905 7.327 0 3.507 1.594 5.92 4.26 6.327 0 .576-1.104 1.808-1.83 2.533 2.915 2.267 5.745-.286 6.869-.792 1.197-.54 2.49-1.004 1.677-1.843Z",
    fill: "#FFD3AB",
    fillRule: "nonzero"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.98 134.793c-9.21-1.717-15.203-8.494-18.937-15.095l-3.12 1.377c1.9 8.482 8.5 20.194 20.579 22.378 6.11 0 5.63-7.886 1.478-8.66Z",
    fill: "url(#EmptyCategoryDetails_svg__H)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m100.675 118.586.012.035c0-1.54-.323-2.436-.918-2.699-.128-.368-.263-.752-.394-1.118-.769-2.148-3.178-3.99-3.69-3.478-.31.308.917 1.253 1.563 2.276.304.487.488 1.04.538 1.61 0 0-2.883.27-2.883 2.66 0 1.944 1.051 1.176 1.051.793.744 1.969 1.627.805 1.97 2.41l3.12-1.377s-.146-.445-.37-1.112Z",
    fill: "#FFD3AB",
    fillRule: "nonzero"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M126.826 115.023c-.77-.396-1.462-.191-1.891-.465-1.02-.623-1.984-1.02-2.524-.724-.27.18-.523.38-.759.602-.53.53-1.618-.597-1.879.77a5.14 5.14 0 0 0-.09 1.062c-2.548.326-1.294 2.641.754 7.102.002-.724 1.543-2.397 1.543.82 0 .345-.259.413-.03.872.228.457 1.692 1.61 2.658 2.575 1.347 1.344 2.139.138 4.367.38-.015-.719.19-1.426.587-2.028a5.916 5.916 0 0 0 1.438-3.662c-1.73.212 1.345-4.467-4.174-7.304Z",
    fill: "#34318F",
    fillRule: "nonzero"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__I)",
    fillRule: "nonzero",
    d: "M419.698 271.46h-59.975l4.223 2.43-43.578 25.106h59.975l43.578-25.105z",
    transform: "translate(2)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M303.968 254.651c0-16.526 13.427-37.66 29.99-47.2 7.9-4.552 15.085-5.641 20.442-3.746-5.416-4.669-14.438-4.572-24.658 1.315-16.563 9.542-29.99 30.676-29.99 47.2v9.387l4.216 2.429v-9.385Z",
    fill: "url(#EmptyCategoryDetails_svg__J)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M330.13 280.961c-.053.031-3.22 1.857-7.005 4.036l-4.98 11.569 4.223 2.43 7.762-18.035Zm-24.162 8.111v-10.281l-4.229 2.434v5.429c0 1.577.507 3.015 1.713 3.48l3.763 2.165c-.872-.62-1.247-1.872-1.247-3.227Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M335.958 207.45c-16.563 9.542-29.99 30.675-29.99 47.201v9.386c0 2.236-6.262 12.883-7.794 16.56-.709 1.75 0 2.684 1.345 1.909 1.344-.776 6.449-3.715 6.449-3.715v10.281c0 2.68 1.465 4.964 5.349 2.727l18.817-10.84-7.766 18.037 43.58-25.104v-53.795c0-16.525-13.427-22.188-29.99-12.647Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M298.174 280.597c.123-.296.28-.64.459-1.019l.088-.186.051-.108.176-.362.127-.255.121-.245.032-.061a98.82 98.82 0 0 1 .552-1.085c2.3-4.478 5.864-10.917 6.166-12.987.013-.08.02-.16.02-.24.002-.01-4.214-2.442-4.214-2.442 0 2.237-6.261 12.883-7.794 16.559-.387.979-.344 1.679-.012 1.996 0 .024 4.333 2.524 4.333 2.524-.44-.268-.536-1.025-.105-2.089Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M313.965 251.834a3.894 3.894 0 0 0-1.77 3.062c.003 1.124.8 1.578 1.782 1.012a3.895 3.895 0 0 0 1.772-3.06c-.003-1.125-.803-1.58-1.784-1.014Z",
    fill: "#2B466D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.055 242.16a2.71 2.71 0 0 1-.2-1.078 6.194 6.194 0 0 1 1.716-3.957 3.323 3.323 0 0 1-.394-1.683 8.193 8.193 0 0 1 3.689-6.404c-.001-.05-.006-.095-.006-.145a8.19 8.19 0 0 1 3.714-6.42c.456-.278.97-.448 1.501-.497a8.3 8.3 0 0 1 3.666-5.73c1.033-.596 1.967-.647 2.64-.25a8.207 8.207 0 0 1 3.355-4.383c1.483-.853 2.758-.585 3.354.519a7.593 7.593 0 0 1 2.641-2.794c1.856-1.069 3.389-.382 3.666 1.507a6.469 6.469 0 0 1 1.502-1.232c2.05-1.182 3.714-.224 3.714 2.14 0 .05-.005.102-.007.153 2.04-1.16 3.69-.202 3.69 2.152a6.601 6.601 0 0 1-.394 2.137c1.007-.095 1.716.643 1.715 1.98a5.471 5.471 0 0 1-.627 2.394c1.262-.194 2.164.68 2.164 2.319a6.37 6.37 0 0 1-.657 2.647c-1.225 2.714.018 4.784-3.852 7.712-2.856 2.161-2.957 4.354-2.957 7.505v25.123l-6.204 3.574v-30.12c0-1.888-1.134-3.189-3.335-1.92l-18.323 10.555c-2.58 1.486-6.959.14-6.959-2.523a5.071 5.071 0 0 1 1.188-3.28Z",
    fill: "url(#EmptyCategoryDetails_svg__K)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.413 294.979a2.542 2.542 0 0 0-.579-.337l-65.217-37.596c-.897-.587-2.969-.958-5.992-.958-5.785 0-12.82 1.35-15.712 3.016l-40.05 23.072L68.52 320h20.95l40.048-23.07c1.291-.745 1.532-1.425.895-1.951Z",
    fill: "url(#EmptyCategoryDetails_svg__L)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__M)",
    xlinkHref: "#EmptyCategoryDetails_svg__N"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__O)",
    xlinkHref: "#EmptyCategoryDetails_svg__N"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M108.273 284.652 70.6 306.355v9.842l37.674-21.703a9.431 9.431 0 0 0 4.27-7.382c0-2.713-1.915-3.817-4.27-2.46Z",
    fill: "#D0D4F6",
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__P)",
    xlinkHref: "#EmptyCategoryDetails_svg__Q"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__R)",
    xlinkHref: "#EmptyCategoryDetails_svg__Q"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "m9.533 271.177 61.066 35.178v9.842L9.532 281.018z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7271",
    fillRule: "nonzero",
    d: "M110.568 284.86 70.52 307.931 4.864 270.108l40.048-23.07z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#52A4A3",
    fillRule: "nonzero",
    d: "m47.207 248.36 61.066 35.179-37.753 21.749-61.067-35.18z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7271",
    fillRule: "nonzero",
    d: "m4.864 270.108 65.656 37.823v1.114L4.863 271.22zM4.864 281.064l65.656 37.823V320L4.863 282.176zM114.37 284.555l-65.655-37.822c-.964-.605-2.309-.556-3.802.304l65.655 37.823 3.802-.305Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M115.805 287.877c0-3.332-2.345-4.683-5.237-3.017L70.52 307.931v1.114l40.048-23.072c2.355-1.356 4.27-.252 4.27 2.46a9.43 9.43 0 0 1-4.27 7.383l-40.048 23.07V320l40.048-23.072c2.892-1.666 5.237-5.718 5.237-9.05Z",
    fill: "#2D7271",
    fillRule: "nonzero"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M61.91 269.256 72 275.068 53.52 285.713 43.432 279.9zM74.101 276.279l2.012 1.16-9.238 5.322-2.013-1.16z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "M68.623 296.597 2.967 258.775l40.533-23.35 65.656 37.822z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "M104.327 265.068v8.316l-38 21.89.001-8.315z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3B378",
    fillRule: "nonzero",
    d: "m2 249.902 41.5-23.906 65.656 37.822-41.5 23.906z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#D67747",
    fillRule: "nonzero",
    d: "m67.657 298.267 41.5-23.907v-1.113l-40.534 23.35v-8.316l40.533-23.35v-1.113l-41.5 23.906z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FC",
    fillRule: "nonzero",
    d: "m52.096 262.621-6.518-3.755 14.45-8.324 6.518 3.755z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "M67.657 298.266 2 260.443v-10.541l65.657 37.822z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "m14.66 265.356-2.255-1.298v-5.783l2.255 1.299zM19.972 268.417l-2.253-1.298v-5.783l2.253 1.299z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.656 298.266h19.64l23.272-13.406c1.43-.823 2.724-.907 3.669-.382l-11.322-6.522-35.259 20.31Z",
    fill: "url(#EmptyCategoryDetails_svg__S)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4 210.057a2.583 2.583 0 0 0 1.214 2.175l1.748 1.008.337.477c.04.053.092.096.15.127 0 0 4.67 2.691 4.696 2.702.123.07.273.072.398.005l55.223 31.813 7.295 2.28-2.79-4.313-57.474-34.756-.222-.315a.455.455 0 0 0-.157-.13s-4.661-2.685-4.693-2.7a.408.408 0 0 0-.396-.003l-.25.144-1.335-.769a2.29 2.29 0 0 0-1.185-.298 2.55 2.55 0 0 0-2.559 2.553Z",
    fill: "url(#EmptyCategoryDetails_svg__T)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M32.738 207.504c.415-.01.824.093 1.185.298l1.67.963c-.16.05-.314.117-.46.201a4.554 4.554 0 0 0-2.066 3.57c-.002.253.044.504.136.739l-1.81-1.043a2.582 2.582 0 0 1-1.214-2.175c0-.677.27-1.327.75-1.806a2.561 2.561 0 0 1 1.809-.747Z",
    fill: "url(#EmptyCategoryDetails_svg__U)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M98.998 247.427a1.473 1.473 0 0 0-.668 1.154c0 .259.111.422.28.464l-4.665-.681-.997-1.415.997-2.564 1.993-1.148 3.585 4.188a.432.432 0 0 0-.525.002Z",
    fill: "url(#EmptyCategoryDetails_svg__V)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M98.998 247.427c.154-.12.37-.12.525-.002l.054.063 1.662 1.94-2.582-.377-.047-.006c-.169-.042-.28-.205-.28-.464.025-.469.274-.897.668-1.154Z",
    fill: "url(#EmptyCategoryDetails_svg__W)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M42.35 215.615c.198-.128.356-.311.452-.527l.808-2.08a.77.77 0 0 0-.078-.645l-.777-1.103a.413.413 0 0 0-.532-.118l-1.625.936a1.219 1.219 0 0 0-.453.527l-.809 2.08a.77.77 0 0 0 .079.644l.777 1.104c.122.167.35.217.532.117l1.625-.935Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED995A",
    fillRule: "nonzero",
    d: "m39.48 214.995 55.468 31.954.997-2.564-55.469-31.954z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#D67747",
    fillRule: "nonzero",
    d: "m40.476 216.41 55.469 31.954-.997-1.415-55.469-31.954z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3B378",
    fillRule: "nonzero",
    d: "m40.476 212.431 55.469 31.954 1.993-1.148-55.468-31.954z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m32.622 211.97.808-2.08c.097-.216.254-.4.453-.528l1.626-.935a.408.408 0 0 1 .395.003c.032.015 4.693 2.7 4.693 2.7a.427.427 0 0 0-.374.012l-1.625.936a1.219 1.219 0 0 0-.453.527l-.809 2.08a.77.77 0 0 0 .079.644l.777 1.104c.029.04.065.075.107.102l-4.67-2.69a.46.46 0 0 1-.151-.128l-.777-1.103a.772.772 0 0 1-.079-.645Z",
    fill: "url(#EmptyCategoryDetails_svg__X)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.619 216.143a.385.385 0 0 1-.108-.102l-.776-1.104a.767.767 0 0 1-.08-.644l.809-2.08c.096-.216.254-.4.453-.527l1.625-.936a.407.407 0 0 1 .368-.008c.006-.003.34.19.34.19a.429.429 0 0 0-.374.01l-1.625.936a1.223 1.223 0 0 0-.453.527l-.808 2.08a.77.77 0 0 0 .079.645l.777 1.104c.028.04.065.075.107.102l-.334-.193Z",
    fill: "#DCE1F4",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.914 215.737a.385.385 0 0 1-.107-.102l-.777-1.104a.766.766 0 0 1-.079-.644l.808-2.08c.097-.216.254-.4.454-.528l1.624-.935a.403.403 0 0 1 .369-.008c.006-.004.34.19.34.19a.429.429 0 0 0-.374.01l-1.625.936a1.22 1.22 0 0 0-.453.528l-.809 2.08a.772.772 0 0 0 .079.644l.777 1.103c.029.041.065.076.107.103l-.334-.193Z",
    fill: "#DCE1F4",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 215.331a.396.396 0 0 1-.108-.102l-.777-1.104a.77.77 0 0 1-.079-.644l.809-2.08c.096-.216.254-.4.453-.527l1.625-.936a.407.407 0 0 1 .368-.008c.006-.003.34.19.34.19a.427.427 0 0 0-.374.011l-1.625.936a1.218 1.218 0 0 0-.453.526l-.808 2.08a.77.77 0 0 0 .078.645l.778 1.104c.028.04.064.075.107.102l-.334-.193Z",
    fill: "#DCE1F4",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyCategoryDetails_svg__Y)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M299.128 208.527h-83.497l-7.586 5.83.533 5.83h70.31z",
    transform: "translate(2)"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M196.125 212.045c4.045 4.037 12.76 7.63 14.81 8.142 2.05-.511 10.763-4.105 14.809-8.142a265.102 265.102 0 0 0-29.619 0Z",
    fill: "#2D7271",
    fillRule: "nonzero"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__Z)",
    xlinkHref: "#EmptyCategoryDetails_svg__aa"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__ab)",
    xlinkHref: "#EmptyCategoryDetails_svg__aa"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyCategoryDetails_svg__ac)",
    xlinkHref: "#EmptyCategoryDetails_svg__ad"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyCategoryDetails_svg__ae)",
    xlinkHref: "#EmptyCategoryDetails_svg__ad"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M238.508 166.438c.004-13.405-9.048-25.129-22.04-28.544-12.992-3.415-26.658 2.337-33.273 14.005-6.616 11.668-4.518 26.318 5.108 35.67 2.246 2.25 2.803 6.318 2.803 7.46 0 2.628 1.74 5.257 5.222 7.263 6.963 4.01 18.251 4.01 25.213 0 3.482-2.006 5.222-4.635 5.222-7.264 0-1.141.557-5.208 2.824-7.47a29.399 29.399 0 0 0 8.92-21.12Z",
    fill: "url(#EmptyCategoryDetails_svg__af)",
    fillRule: "nonzero",
    transform: "translate(2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.328 187.767c6.963-4.011 18.25-4.011 25.213 0 6.963 4.01 6.963 10.513 0 14.525-6.962 4.01-18.25 4.01-25.213 0-6.963-4.012-6.963-10.515 0-14.525Z",
    fill: "url(#EmptyCategoryDetails_svg__ag)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(2)"
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M187.332 166.438c0-13.006 10.567-23.55 23.602-23.55",
    stroke: "#FFF",
    strokeWidth: 4.917,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.544 162.939a1.15 1.15 0 0 0-1.189.008c-.816.47-1.423 2.007-1.814 3.96a2.903 2.903 0 0 0-1.058-1.629 1.15 1.15 0 0 0-1.189.009c-.815.47-1.423 2.006-1.814 3.959a2.901 2.901 0 0 0-1.057-1.629 1.15 1.15 0 0 0-1.19.009c-.815.47-1.421 2.006-1.814 3.96a2.903 2.903 0 0 0-1.057-1.63 1.15 1.15 0 0 0-1.189.009c-1.535.885-2.338 5.526-2.338 9.654 0 4.203 1.004 5.445 1.975 6.646 1.025 1.27 2.086 2.582 2.086 8.192a.614.614 0 0 0 1.23 0c0-6.043-1.253-7.594-2.359-8.962-.913-1.13-1.702-2.106-1.702-5.876 0-4.677.99-8.128 1.71-8.58.396.264 1.121 2.332 1.12 6.241a.614.614 0 0 0 1.23 0c.001-4.678.992-8.129 1.71-8.58.397.264 1.122 2.332 1.122 6.241a.614.614 0 0 0 1.23 0c0-4.678.99-8.129 1.708-8.58.397.263 1.122 2.332 1.122 6.24a.614.614 0 0 0 1.23 0c0-4.677.99-8.128 1.709-8.579.397.264 1.122 2.333 1.122 6.24a18.797 18.797 0 0 1-1.804 8.238 25.575 25.575 0 0 0-2.257 11.279.614.614 0 0 0 1.23 0c-.119-3.722.621-7.42 2.164-10.81a19.826 19.826 0 0 0 1.897-8.706c0-3.05-.464-6.575-1.764-7.324Z",
    fill: "url(#EmptyCategoryDetails_svg__ah)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(2)"
  })));
};
export default SvgEmptyCategoryDetails;